const MAX_HOPS = 500;

export function word(forward=true, sequencerEngine) {
    let cursor = sequencerEngine.cursor;
    let step = cursor.step;

    if (inWord(sequencerEngine)) {
        goToEndOfWord(sequencerEngine, forward);
    } 

    goToNextWord(sequencerEngine, forward);
}

export function inWord(sequencerEngine) {
    let stepNumber = sequencerEngine.cursor.getStep(sequencerEngine.resolution);
    let p = sequencerEngine.getSelectedTrack().getEasyPattern();
    let steps = p.getStepsAtStepNumber(stepNumber, sequencerEngine.resolution)
        .map(x => x.step);
    return steps.some(x => x.on);
}

export function goToNextWord(sequencerEngine, forward=true) {
    let step = sequencerEngine.getSelectedStepData();
    let firstWord = step;
    let visited = new Set();
    let counter=0;
    while (!step.on) {
        counter++;
        visited.add(step.id);
        if (forward) {
            sequencerEngine.right(false);
        } else {
            sequencerEngine.left(false);
        }
        step = sequencerEngine.getSelectedStepData();
        if (visited.has(step.id) || counter > MAX_HOPS) {
            sequencerEngine.cursor.updateRedux();
            return;
        }
    }
    sequencerEngine.cursor.updateRedux();
}

export function goToEndOfWord(sequencerEngine, forward=true) {
    let step = sequencerEngine.getSelectedStepData();
    let firstWord = step;
    let visited = new Set();
    while (step.on) {
        visited.add(step.id);
        if (forward) {
            sequencerEngine.right(false);
        } else {
            sequencerEngine.left(false);
        }
        step = sequencerEngine.getSelectedStepData();
        if (visited.has(step.id)) {
            sequencerEngine.cursor.updateRedux();
            return;
        }
    }
    sequencerEngine.cursor.updateRedux();
}
